import axios from '@/plugins/axios'

export default {
  namespaced: true,

  state: {
    countries: [],
    preview: false
  },

  mutations: {
    setCountries(state, payload) {
      state.countries = payload
    },
    setPreview(state, payload) {
      state.preview = payload
    }
  },

  actions: {
    readCountries({ commit }) {
      axios.admin.get('countries').then(r => {
        commit('setCountries', r.data.data)
      })
    }
  }
}
